<template>
  <v-snackbar v-model="localShow" :timeout="timeout" @input="toggle">
    {{ text }}

    <template #action="{ attrs }">
      <v-btn
        :color="color"
        text
        v-bind="attrs"
        @click="$emit('update:show', false)"
      >
        Закрыть
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "Snackbar",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Number,
      default: 3000
    },
    color: {
      type: String,
      default: "blue"
    },
    text: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localShow: this.show
    };
  },
  watch: {
    show() {
      this.localShow = this.show;
    }
  },
  methods: {
    toggle(value) {
      this.$emit("update:show", value);
    }
  }
};
</script>
